import React from 'react';
import { Button } from '../../../ui';

const PricingPlansTable = props => {
  const { data: pricingPlans, active, currency } = props;

  return (
    <table className="w-full">
      <thead>
        <tr className="text-left bg-[#EEEAF9]">
          <th className="p-[16px]">Features</th>
          <th className="hidden md:table-cell p-[16px]">Plan for Activation</th>
          <th className="hidden md:table-cell p-[16px]">Plan for Acceleration</th>
          <th className="hidden md:table-cell p-[16px]">Plan for Victory</th>
          <th className="table-cell md:hidden p-[16px] w-120"></th>
        </tr>
      </thead>
      <tbody>
        {pricingPlans.map((item, index) => (
          <tr key={index} className={`${index % 2 === 0 ? `bg-white` : `bg-[#EEEAF9]`}`}>
            <td>
              {index === 0 || index === 1 ? (
                <p className="max-w-[200px] md:max-w-[320px] p-[16px] text-[18px] leading-[22px] font-[600] italic">{item.feature}</p>
              ) : (
                <p className="max-w-[200px] md:max-w-[320px] p-[16px] text-[16px] leading-[20px] font-[500]">{item.feature}</p>
              )}
            </td>
            <td className="p-[16px] hidden md:table-cell">
              <div className="flex items-center justify-center text-center">
                {item.activation.length || typeof item.activation === 'object' ? (
                  item.feature === 'Get Started' ? (
                    <a href={`/seo/seo-form`}>
                      <Button variant="primary" narrowing="both" mode="light" className={'!py-[9px] !px-[30px]'}>
                        {item.activation}
                      </Button>
                    </a>
                  ) : (
                    <p
                      className={`max-w-[200px] md:max-w-[320px] p-[16px]  ${index === 0 || index === 1 ? 'leading-[29px] font-[700] text-[24px] text-[#0052B4]' : 'text-[16px] leading-[20px] font-[500]'} `}
                    >
                      {typeof item.activation === 'object' ? item.activation[currency] : item.activation}
                    </p>
                  )
                ) : (
                  <img src={`/images/seo/icons/${!!item.activation ? `check` : `minus`}.svg`} alt={item.feature} className="w-[20px]" />
                )}
              </div>
            </td>
            <td className="p-[16px] hidden md:table-cell">
              <div className="flex items-center justify-center text-center">
                {item.acceleration.length || typeof item.acceleration === 'object' ? (
                  item.feature === 'Get Started' ? (
                    <a href={`/seo/seo-form`}>
                      <Button variant="primary" narrowing="both" mode="light" className={'!py-[9px] !px-[30px]'}>
                        {item.acceleration}
                      </Button>
                    </a>
                  ) : (
                    <p
                      className={`max-w-[200px] md:max-w-[320px] p-[16px]  ${index === 0 || index === 1 ? 'leading-[29px] font-[700] text-[24px] text-[#0052B4]' : 'text-[16px] leading-[20px] font-[500]'} `}
                    >
                      {typeof item.acceleration === 'object' ? item.acceleration[currency] : item.acceleration}
                    </p>
                  )
                ) : (
                  <img src={`/images/seo/icons/${!!item.acceleration ? `check` : `minus`}.svg`} alt={item.feature} className="w-[20px]" />
                )}
              </div>
            </td>
            <td className="p-[16px] hidden md:table-cell">
              <div className="flex items-center justify-center text-center">
                {item.victory.length || typeof item.victory === 'object' ? (
                  item.feature === 'Get Started' ? (
                    <a href={`/seo/seo-form`}>
                      <Button variant="primary" narrowing="both" mode="light" className={'!py-[9px] !px-[30px]'}>
                        {item.victory}
                      </Button>
                    </a>
                  ) : (
                    <p
                      className={`max-w-[200px] md:max-w-[320px] p-[16px]  ${index === 0 || index === 1 ? 'leading-[29px] font-[700] text-[24px] text-[#0052B4]' : 'text-[16px] leading-[20px] font-[500]'} `}
                    >
                      {typeof item.victory === 'object' ? item.victory[currency] : item.victory}
                    </p>
                  )
                ) : (
                  <img src={`/images/seo/icons/${!!item.victory ? `check` : `minus`}.svg`} alt={item.feature} className="w-[20px]" />
                )}
              </div>
            </td>
            <td className="p-[16px] table-cell md:hidden">
              <div className="flex items-center justify-center text-center">
                {item[active].length || typeof item[active] === 'object' ? (
                  item[active] === 'Choose a plan' ? (
                    <a href={`/seo/seo-form`}>
                      <Button variant="primary" narrowing="both" mode="light" className={'!py-[9px] md:!px-[30px] !px-[23px]'}>
                        {item[active]}
                      </Button>
                    </a>
                  ) : (
                    <p
                      className={`max-w-[200px] md:max-w-[320px] p-[16px]  ${index === 0 || index === 1 ? 'leading-[29px] font-[700] text-[24px] text-[#0052B4]' : 'text-[16px] leading-[20px] font-[500]'} `}
                    >
                      {typeof item[active] === 'object' ? item[active][currency] : item[active]}
                    </p>
                  )
                ) : (
                  <img src={`/images/seo/icons/${!!item[active] ? `check` : `minus`}.svg`} alt={item.feature} className="w-[20px]" />
                )}
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default PricingPlansTable;
